import React, { useContext, useEffect, useState } from "react";
import DFNotePin from "./DFIcons/DFNotePin";
import { Menu } from "@material-ui/core";
import useModal from "hooks/useModal";
import DFMenuItem from "./DFCustoms/DFMenuItem";
import DFIconButton from "./DFCustoms/DFIconButton";
import MoreVertOutlinedIcon from "@material-ui/icons/MoreVertOutlined";
import { PinnedLogsContext } from "./AllLogHistoryNew";
import useCommunication from "hooks/context-hooks/useCommunication";
import { useUpdatePinnedLog } from "utils/hooks/apiHooks/notes-feature/useUpdatePinnedLog";

export default function ChatBubbleMenu({
  logId,
  callType,
  isPinned,
}: {
  logId: string;
  callType: "web_form_log" | "chat_widget" | "sms_log" | "call_log" | "note";
  isPinned: boolean;
}) {
  const [anchorEl, closeModal, openModal] = useModal("contact_card_popover");
  //@ts-ignore
  const handleClick = (event) => {
    openModal(event.currentTarget);
    event.stopPropagation();
  };
  const [innerIsPinned, setInnerIsPinned] = useState<boolean>();
  useEffect(() => {
    setInnerIsPinned(isPinned);
  }, [isPinned]);

  const [updatePinnedStatus] = useUpdatePinnedLog(() => {
    setInnerIsPinned(!innerIsPinned);
  });

  return (
    <>
      {/* @ts-ignore */}
      <DFIconButton
        style={{ marginTop: "auto", marginBottom: "auto" }}
        tooltip="More"
        onClick={handleClick}
        icon={<MoreVertOutlinedIcon fontSize="small" />}
      />

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={(event: any) => {
          closeModal();
          event.stopPropagation();
        }}
      >
        <DFMenuItem
          onClick={(event: any) => {
            closeModal();
            updatePinnedStatus({
              logId: logId,
              callType: callType,
              isPinned: !innerIsPinned,
            });
            event.stopPropagation();
          }}
          icon={<DFNotePin isPinned />}
          text={innerIsPinned ? "Unpin" : "Pin to top"}
        />
      </Menu>
    </>
  );
}
